"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverVettingAndProtectiveMeasures = exports.eProtectiveMeasures = exports.eDriverVettingMeasures = void 0;
const commoditiesAndProtection_class_1 = __importDefault(require("./commoditiesAndProtection.class"));
var eDriverVettingMeasures;
(function (eDriverVettingMeasures) {
    eDriverVettingMeasures["NONE_APPLY"] = "None Apply";
    eDriverVettingMeasures["BACKGROUND_CHECKS_CRIMINAL"] = "Background Checks (Criminal)";
    eDriverVettingMeasures["BACKGROUND_CHECKS_PRIOR"] = "Background Checks (Prior-Employment)";
    eDriverVettingMeasures["MOTOR_VEHICLE_RECORD"] = "Motor Vehicle Record (MVR) Review";
    eDriverVettingMeasures["PRE_EMPLOYMENT_REFERENCE_CHECK"] = "Pre-Employment Reference Checks";
    eDriverVettingMeasures["PRE_EMPLOYMENT_DRUG_TEST"] = "Pre-Employment Drug Test";
    eDriverVettingMeasures["ONGOING_PERIODIC_DRUG_TESTING"] = "Ongoing Periodic Drug Testing";
    eDriverVettingMeasures["PRE_EMPLOYMENT_ROAD_TEST"] = "Pre-Employment Road Test";
    eDriverVettingMeasures["FMCSA_PRE_EMPLOYMENT_SCREENING"] = "FMCSA Pre-Employment Screening (PSP) Report Review";
})(eDriverVettingMeasures = exports.eDriverVettingMeasures || (exports.eDriverVettingMeasures = {}));
var eProtectiveMeasures;
(function (eProtectiveMeasures) {
    eProtectiveMeasures["NONE_APPLY"] = "None Apply";
    eProtectiveMeasures["PRE_POST_TRIP_INSPECTIONS"] = "Pre / Post-trip Inspections";
    eProtectiveMeasures["DRIVER_FACING_CAMERAS"] = "Driver-Facing Cameras";
    eProtectiveMeasures["ELECTRONIC_LOGGING_DEVICE"] = "Electronic Logging Device (ELD)";
    eProtectiveMeasures["DRIVER_INCENTIVE_PROGRAM"] = "Driver Incentive Program Rewarding Safe Driving";
    eProtectiveMeasures["ESTABLISHED_DRIVER_TRINING_PROGRAM"] = "Formal/Established Driver Training Program";
    eProtectiveMeasures["ESTABLISHED_VEHICLE_MAINTENANCE_PROGRAM"] = "Formal/Established Vehicle Maintenance Program";
    eProtectiveMeasures["INSTALLED_VEHICLE_TELEMATICS_DEVICES"] = "Installed Vehicle Telematics Devices";
    eProtectiveMeasures["TEMPERATURE_ALARMS"] = "Temperature Alarms (Refrigeration Units)";
    eProtectiveMeasures["TEMPERATURE_MONITORING_DEVICE"] = "Temperature Monitoring Device (Refrigeration Units)";
    eProtectiveMeasures["FULL_TIME_SAFETY_INSPECTOR"] = "Full Time Safety Inspector";
    eProtectiveMeasures["GPS_SATELLITE_TRACKING"] = "GPS/Satellite Tracking";
})(eProtectiveMeasures = exports.eProtectiveMeasures || (exports.eProtectiveMeasures = {}));
class DriverVettingAndProtectiveMeasures {
    constructor(data) {
        this.driverVettingMeasures = data.driverVettingMeasures;
        this.protectiveMeasures = data.protectiveMeasures;
    }
    static empty() {
        const data = {
            driverVettingMeasures: [],
            protectiveMeasures: []
        };
        return new DriverVettingAndProtectiveMeasures({
            driverVettingMeasures: data.driverVettingMeasures,
            protectiveMeasures: data.protectiveMeasures
        });
    }
    static fromObj(data) {
        return new DriverVettingAndProtectiveMeasures(data);
    }
}
exports.DriverVettingAndProtectiveMeasures = DriverVettingAndProtectiveMeasures;
exports.default = commoditiesAndProtection_class_1.default;
//# sourceMappingURL=index.js.map